import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import * as React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { Typography, IconButton, Divider } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
import { CONSTANTS_STRINGS } from "../../Utils/Constant";

export default function Menuicon() {
  const [isOpen, setIsOpen] = React.useState(false);
  const data = CONSTANTS_STRINGS.menuicon;

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };

  const list = () => (
    <Box
      sx={{
        width: 350,
        padding: 3,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        position: "relative",
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton
          sx={{
            backgroundColor: "#fff",
            color: "#000",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            "&:hover": {
              backgroundColor: "#000",
              color: "#fff",
            },
          }}
        >
          <AiOutlineClose size={40} />
        </IconButton>
      </Box>

      <Typography variant="h4" fontWeight="bold">
        {data.title}
      </Typography>

      <Typography variant="body1" color="text.secondary">
        {data.description}
      </Typography>

      <Divider />

      <Typography variant="h4">{data.contactTitle}</Typography>
      <Typography variant="body1">
        <strong>Address:</strong> {data.address}
      </Typography>
      <Typography variant="body2">
        <strong>Email:</strong> {data.email}
      </Typography>
      <Typography variant="body2">
        <strong>Call:</strong> {data.phone}
      </Typography>
    </Box>
  );

  return (
    <div>
      <Button onClick={toggleDrawer(true)}>
        <MenuIcon sx={{ color: "#000" }} fontSize="large" />
      </Button>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={toggleDrawer(false)}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}
